import { useAppDispatch } from "app/hooks"
import { hideCustomSnackbar, showCustomSnackbar } from "./notificationSlice"
import { ICustomSnackbarInfo } from "./hooks"

const SNACKBAR_DURATION = 2750

export const useShowCustomSnackbar = () => {
  const dispatch = useAppDispatch()

  const handleShowCustomSnackbar = (payload: ICustomSnackbarInfo) => {
    dispatch(showCustomSnackbar(payload))

    setTimeout(() => {
      dispatch(hideCustomSnackbar())
    }, SNACKBAR_DURATION)
  }

  const handleHideCustomSnackbar = () => {
    dispatch(hideCustomSnackbar())
  }

  return { handleShowCustomSnackbar, handleHideCustomSnackbar }
}
